module.exports = __webpack_public_path__ + "static/media/computer.9d7c56c0.svg";